// Mock data for the AI summary prototype (ENT-3361). Replaced by the real API once the backend is ready.
// A session is a room for now: there is no session hierarchy inside a room yet.
//
// Message `time` is the offset in seconds from the start of the recording.

const hms = (h, m, s = 0) => h * 3600 + m * 60 + s;

export const MOCK_TRANSCRIPTS = [
  {
    conference_id: 'mock-tech-summit',
    title: 'Tech Summit',
    room_type: 'permanent',
    timestamp: '2026-09-10T13:00:00Z',
    duration_minutes: 55,
    recording_duration: hms(2, 15),
    messages: [
      { time: hms(0, 45), display_name: 'Maya Chen', source: 'Welcome to Tech Summit. Today brings together founders, product teams, and technology leaders. We\'ll share practical ideas, compare experiences, and make time for new connections.' },
      { time: hms(0, 47, 12), display_name: 'Maya Chen', source: 'Our program has three parts: keynote talks on the main stage, discussions in the panel room, and hands-on workshops. Choose the sessions that best match your goals for the day.' },
      { time: hms(0, 51, 8), display_name: 'Maya Chen', source: 'After the opening talk, join AI at Work for practical workflow ideas. Future of Work explores team changes, while Startup Stories shares lessons from founders building new businesses.' },
      { time: hms(0, 55, 2), display_name: 'Maya Chen', source: 'Please use the session transcript to revisit anything you missed. Each summary covers one session, with takeaways and speaker highlights linked to their place in the recording.' },
      { time: hms(1, 5), display_name: 'Maya Chen', source: 'For audience questions, wait for the microphone so everyone can follow. Introduce yourself briefly and keep your question focused. We\'ll save time for a discussion after each talk.' },
      { time: hms(1, 15), display_name: 'Maya Chen', source: 'During the breaks, meet someone outside your usual field. Share what you are working on and what you hope to learn. The networking session is a good place to continue these conversations.' },
      { time: hms(1, 30), display_name: 'Maya Chen', source: 'Before you leave, choose one idea to bring back to your team. Save the relevant session summary and follow up with the people you met. Thank you for being part of Tech Summit.' },
    ],
  },
  {
    conference_id: 'mock-main-stage',
    title: 'Main stage',
    room_type: 'permanent',
    timestamp: '2026-09-10T14:00:00Z',
    duration_minutes: 55,
    recording_duration: hms(2, 15),
    messages: [
      { time: hms(0, 45), display_name: 'Maya Chen', source: 'Welcome to AI at Work at Tech Summit. Today we\'ll explore practical AI workflows. Start with one repetitive task, such as drafting a meeting recap, rather than replacing a whole process.' },
      { time: hms(0, 47, 12), display_name: 'Maya Chen', source: 'Think of AI as a copilot, not an autopilot. It can draft a recap or suggest a reply, but a person checks the facts, adds context, and approves the final output before it is shared.' },
      { time: hms(0, 51, 8), display_name: 'Maya Chen', source: 'Run a small pilot with a clear owner. Measure time saved and output quality against your current workflow. Use approved tools and keep sensitive customer data out of prompts.' },
      { time: hms(0, 55, 2), display_name: 'Maya Chen', source: 'Before scaling, add human review and a privacy check. A faster draft is not useful if it is wrong. Keep a record of errors, gather feedback, and improve the workflow before expanding it.' },
      { time: hms(1, 5), display_name: 'Daniel Ortiz', source: 'An audience member asks: how can a small team test AI without exposing customer information? Start with sample data and choose a low-risk internal task before handling real records.' },
      { time: hms(1, 15), display_name: 'Maya Chen', source: 'Use an approved tool with clear data controls. Remove names and account details from test inputs. If you cannot confirm how a tool handles your data, do not upload sensitive information.' },
      { time: hms(1, 30), display_name: 'Maya Chen', source: 'To wrap up: pick one workflow, name an owner, measure the result, and keep a person responsible for the final output. Thank you, and enjoy the rest of the summit.' },
    ],
  },
  {
    conference_id: 'mock-panel-room',
    title: 'Panel room',
    room_type: 'permanent',
    timestamp: '2026-09-10T15:00:00Z',
    duration_minutes: 38,
    recording_duration: hms(0, 38),
    messages: [
      { time: hms(0, 0, 30), display_name: 'Priya Natarajan', source: 'Welcome to Future of Work. Our panel looks at how teams are changing as more work becomes distributed and more tasks are supported by software.' },
      { time: hms(0, 4, 10), display_name: 'Tom Becker', source: 'The biggest change we saw was not tools, it was expectations. People want clear priorities and the freedom to choose how they reach them.' },
      { time: hms(0, 9, 45), display_name: 'Priya Natarajan', source: 'How do you keep a distributed team aligned without adding more meetings?' },
      { time: hms(0, 10, 20), display_name: 'Tom Becker', source: 'Write decisions down. A short written update every week replaced two of our recurring meetings, and new joiners can read the history instead of asking around.' },
      { time: hms(0, 21, 5), display_name: 'Lena Fischer', source: 'Accessibility has to be part of this. Captions and transcripts help people who join late, work in another language, or simply need to review what was said.' },
      { time: hms(0, 33, 40), display_name: 'Priya Natarajan', source: 'Last question for everyone: one habit to start next week? Write it down, share it with your team, and check back in a month.' },
    ],
  },
  {
    conference_id: 'mock-workshop-room',
    title: 'Workshop room',
    room_type: 'permanent',
    timestamp: '2026-09-10T17:00:00Z',
    duration_minutes: 31,
    recording_duration: hms(0, 31),
    messages: [
      { time: hms(0, 1), display_name: 'Sam Rivera', source: 'Welcome to Startup Stories. This workshop is about lessons founders learned the hard way, so you can skip a few of them.' },
      { time: hms(0, 6, 15), display_name: 'Sam Rivera', source: 'Our first product solved a problem nobody was paying for. Talk to ten customers before you write the first line of code, and ask what they do today instead.' },
      { time: hms(0, 14, 50), display_name: 'Sam Rivera', source: 'Hire for the stage you are in. Early on you need people who are comfortable with unclear roles and changing plans.' },
      { time: hms(0, 24, 30), display_name: 'Sam Rivera', source: 'Finally, keep a simple weekly metric that everyone understands. When the number moves, the whole team should know why.' },
    ],
  },
  {
    conference_id: 'mock-opening-talk',
    title: 'Opening talk',
    room_type: 'single',
    timestamp: '2026-09-10T13:00:00Z',
    duration_minutes: 55,
    recording_duration: hms(0, 55),
    messages: [
      { time: hms(0, 0, 40), display_name: 'Maya Chen', source: 'Good morning and welcome. This year we have more sessions than ever, so let\'s start with how to make the most of the day.' },
      { time: hms(0, 8, 5), display_name: 'Maya Chen', source: 'Every session is captioned and translated live. You can follow along on your phone in your own language.' },
      { time: hms(0, 19, 30), display_name: 'Maya Chen', source: 'Transcripts are saved to your account after each session, and you can generate an AI summary for any of them.' },
      { time: hms(0, 41, 12), display_name: 'Maya Chen', source: 'Enjoy the summit, and don\'t forget to tell us what worked and what didn\'t.' },
    ],
  },
  {
    conference_id: 'mock-founder-panel',
    title: 'Founder panel',
    room_type: 'single',
    timestamp: '2026-09-10T18:00:00Z',
    duration_minutes: 40,
    recording_duration: hms(0, 40),
    messages: [
      { time: hms(0, 0, 20), display_name: 'Alex Morgan', source: 'Thanks for joining the founder panel. Let\'s begin with the decision each of you would make differently today.' },
      { time: hms(0, 5, 0), display_name: 'Jordan Lee', source: 'I would have raised less money and spent more time with early customers. Funding hid problems we should have fixed sooner.' },
      { time: hms(0, 17, 25), display_name: 'Casey Wong', source: 'For me it was hiring. We grew the team before we knew which roles we actually needed.' },
      { time: hms(0, 32, 10), display_name: 'Alex Morgan', source: 'Great place to stop. Thank you both, and thanks to everyone for the questions.' },
    ],
  },
  {
    conference_id: 'mock-networking',
    title: 'Networking',
    room_type: 'single',
    timestamp: '2026-09-10T20:00:00Z',
    duration_minutes: 24,
    recording_duration: hms(0, 24),
    // The first summary request for this session fails, so the error state can be reviewed.
    mock_fail_first_summary: true,
    messages: [
      { time: hms(0, 0, 15), display_name: 'Maya Chen', source: 'Welcome to the networking session. Find someone you haven\'t met yet and share one idea from today.' },
      { time: hms(0, 9, 40), display_name: 'Maya Chen', source: 'Five more minutes in this round, then we\'ll switch groups.' },
      { time: hms(0, 20, 5), display_name: 'Maya Chen', source: 'Thank you all. Drinks are in the main hall, and the transcripts will be in your account tonight.' },
    ],
  },
];

// Hand-written summaries; the rest are built from the transcript in the mock service.
export const MOCK_SUMMARIES = {
  'mock-main-stage': {
    key_takeaways: [
      { title: 'Start with one workflow.', text: 'Pilot AI on a repetitive task, such as a meeting recap, before changing an entire process.', start: hms(0, 45) },
      { title: 'Keep people in control.', text: 'AI drafts the output; a person checks facts, adds context, and approves it before sharing.', start: hms(0, 47, 12) },
      { title: 'Measure a safe pilot.', text: 'Assign an owner, track time saved and quality, and keep sensitive data out of prompts.', start: hms(0, 51, 8) },
    ],
    speaker_highlights: [
      { title: 'Copilot, not autopilot.', text: 'AI assists with a draft; the human reviewer remains responsible for the final output.', label: 'Speaker analogy', start: hms(0, 47, 12) },
      { title: 'Scale only after review.', text: 'Start with a small pilot using approved tools. Measure time saved and output quality, check privacy, and log errors. Gather team feedback and improve the workflow before expanding it. Faster output is not a success if it is inaccurate.', start: hms(0, 51, 8), end: hms(0, 55, 2) },
    ],
    follow_up_questions: [
      { text: 'Which repetitive task on your team is low-risk enough for a first pilot?', start: hms(0, 45) },
      { text: 'Who reviews AI drafts before they are shared, and how is that recorded?', start: hms(0, 47, 12) },
      { text: 'How will you test with sample data before touching real customer records?', start: hms(1, 5) },
    ],
  },
};
